export default "__VITE_ASSET__CcO$IohC__"